import OadpTable from './oadp-table';
export default OadpTable;
